import { GenericOption } from 'pages/AutomationEngine/types';
import { TFunction } from 'react-i18next';
import { CONFLICT_RESOLUTIONS, DESTINATION_TYPES } from './constants';
import { DestinationType } from './llm-types';
import {
  AudioTranscriptionStep,
  CallLlmStep,
  FileExtractionStep,
} from '../actionSectionTypes';

export const getDestinationFieldOptions = (
  isGlobalAutomation: boolean,
  t: TFunction
) =>
  [
    !isGlobalAutomation && {
      value: DESTINATION_TYPES.this_object_field,
      label: t('Field on this Object'),
    },
    {
      value: DESTINATION_TYPES.variable,
      label: t('Variable'),
    },
    !isGlobalAutomation && {
      value: DESTINATION_TYPES.related_object_field,
      label: t('Field on Related Object'),
    },
  ].filter(Boolean) as GenericOption<DestinationType>[];

export const getConflictResolutionOptions = (isMulti: boolean, t: TFunction) =>
  [
    {
      value: CONFLICT_RESOLUTIONS.overwrite,
      label: t('Overwrite'),
    },
    {
      value: CONFLICT_RESOLUTIONS.overwrite_except_null,
      label: t('Overwrite (Skip Blanks)'),
    },
    {
      value: CONFLICT_RESOLUTIONS.update_if_blank,
      label: t('Update if Blank'),
    },
    {
      value: CONFLICT_RESOLUTIONS.add_only,
      label: t('Only Add Options'),
    },
  ].filter((v) => isMulti || v.value !== CONFLICT_RESOLUTIONS.add_only);

export const removeLLMVariable = (
  step: CallLlmStep | FileExtractionStep | AudioTranscriptionStep,
  variableName: string
) => {
  const nextErrorIds: Set<string> = new Set();

  const nextStep = {
    ...step,
    details: {
      ...step.details,
      destinations: step.details.destinations.map((destination) => {
        if (
          destination.destinationType === DESTINATION_TYPES.variable &&
          destination.variable?.label === variableName
        ) {
          nextErrorIds.add(step.id);

          return {
            ...destination,
            variable: { ...(destination.variable ?? {}), deleted: true },
          };
        }

        return destination;
      }),
    },
    hasError: true,
  };

  return {
    nextStep: nextErrorIds.size ? nextStep : step,
    nextErrorIds: [...nextErrorIds],
  };
};
